// =============================================================================
// Back-office: claves de API
// =============================================================================
import { apiClient } from './http';

export interface ApiKeyRow {
  id: number;
  name: string;
  masked: string;
  created_at: string;
  last_used_at: string | null;
}

export async function getApiKeys(): Promise<ApiKeyRow[]> {
  const res = await apiClient.get<ApiKeyRow[]>('/integration/keys');
  return res.data;
}

/** Devuelve la clave EN CLARO. Es la única vez que existe: no se puede recuperar. */
export async function createApiKey(name: string): Promise<{ api_key: string }> {
  const res = await apiClient.post<{ api_key: string }>('/integration/keys', { name });
  return res.data;
}

export async function revokeApiKey(id: number): Promise<void> {
  await apiClient.delete(`/integration/keys/${id}`);
}
